import React, { Component } from 'react'
import { Link } from 'gatsby'

import './style.scss'

class StateSwitcher extends Component {
  render() {
    const state = this.props.state
    const slug = this.props.slug
    const site = this.props.site
    return (
      <div className={'switcher ' + (!state && 'disabled')}>
        <Link
          className={
            'switcher__tab ' + (state === 'design' && 'switcher__tab--active')
          }
          to={
            '/' + site + '/' + (slug && slug.replace('/develop/', '/design/'))
          }
        >
          Design
        </Link>
        <Link
          className={
            'switcher__tab ' + (state === 'develop' && 'switcher__tab--active')
          }
          to={
            '/' + site + '/' + (slug && slug.replace('/design/', '/develop/'))
          }
        >
          Develop
        </Link>
      </div>
    )
  }
}

export default StateSwitcher
